import * as bg06 from '../actions/bg06.actions';
import * as moment from 'moment';
export interface State {
  page_content: any;
}
export const initialState = {
    page_content: {}
};

export function reducer(state = initialState, action: bg06.Actions) {
  switch (action.type) {
    case bg06.GO_TO_PAGE_BG06: {
      const data = transformResponse(action.payload);
      return Object.assign({}, state, {
        ...state,
        page_content: {
          raw_data: data.res,
          data: data.data
        }
      });
    }

    default:
      return state;
  }
}

function transformResponse(data) {
  data = data['policyEStatement'];
  return {
    res: data,
    data: data.map(e => {
      return {
        BG06_06: e['policyNo'],
        BG06_07: e['clientName'],
        BG06_08: moment(e['createdDate']).format('YYYY-MM-DD'),
        BG06_09: e['letterType']
      };
    })
  };
}
